module.exports = __webpack_public_path__ + "static/mobile-mock-web-288827f0188b8eca862b2b9cb80ca982.svg";